<script setup>
import { backgrounds } from '@/config/seo-banner';
import { getInitialFilters } from '@/stores/search';

const props = defineProps({
  sections: {
    type: Array,
    required: true,
  },
});

// breakpoint
const breakpoint = useCustomBreakpoints();
const breakpointDownSm = breakpoint.smaller('sm');

// Scroll handling
const isPageScrolled = ref(false);

useEventListener('scroll', handleScroll);

function handleScroll() {
  if (breakpointDownSm.value) return;
  isPageScrolled.value = window.scrollY > toResizedPx(300);
}

const components = {
  header: resolveComponent('LazySeoHeader'),
  related: resolveComponent('LazySeoRelated'),
  text: resolveComponent('LazySeoText'),
  facts: resolveComponent('LazySeoFacts'),
  network_map: resolveComponent('LazySeoMap'),
  mobile_app_ad: resolveComponent('LazySectionMainApp'),
  benefits: resolveComponent('LazySeoBenefits'),
  featured_pages_large: resolveComponent('LazySeoFeaturedPages'),
  featured_pages_small: resolveComponent('LazySeoFeaturedPages'),
  faq: resolveComponent('LazySeoFaq'),
  featured_pages_grid: resolveComponent('LazySeoFeaturedPagesGrid'),
  top_links_list: resolveComponent('LazySeoLinks'),
  featured_classes: resolveComponent('LazySeoClasses'),
  photos_slider: resolveComponent('LazySeoPhotosSlider'),
  luggage: resolveComponent('LazySeoLuggage'),
  featured_pages_small_alt: resolveComponent('LazySeoFeaturedPages'),
  text_banner_large: resolveComponent('LazySeoTextBannerLarge'),
  facts_large: resolveComponent('LazySeoFacts'),
  facts_banner: resolveComponent('LazySeoFactsBanner'),
  timetable: resolveComponent('LazySeoTimetable'),
  featured_pages: resolveComponent('LazySeoFeaturedPages'),
  text_banner: resolveComponent('LazySeoTextBanner'),
  featured_facts: resolveComponent('LazySeoFeaturedFacts'),
  facts_slider: resolveComponent('LazySeoFactsSlider'),
};

const sectionsFiltered = computed(() =>
  filterAdaptedSections(props.sections, components, 'BundlesSeo.vue'),
);

// Initial form state
const searchStore = useSearchStore();
const previousSearch = usePreviousSearch();

onMounted(() => {
  const headerSection = sectionsFiltered.value.find(
    (section) => section.type === 'header',
  );

  if (!headerSection) return;

  setTimeout(() => updateFilters(headerSection.data?.form));
});

function updateFilters(data) {
  const filters = {
    ...getInitialFilters(),
    departureStation: data?.departureLocation,
    arrivalStation: data?.arrivalLocation,
  };

  previousSearch.add(filters);
  searchStore.updateFilters(filters);
}
</script>

<template>
  <div class="bundles-seo">
    <template
      v-for="(section, sectionIndex) in sectionsFiltered"
      :key="sectionIndex"
    >
      <Component
        :is="components[section.type]"
        class="bundles-seo__section"
        :class="[
          `bundles-seo__section--${section.type}`,
          {
            'bundles-seo__section--without-margins':
              section.data.withoutMargins,
          },
        ]"
        v-bind="section.data"
      />
    </template>

    <div class="bundles-seo__slider-container hidden-mobile">
      <ClientOnly>
        <SliderSeoBanner
          v-if="!breakpointDownSm"
          class="bundles-seo__slider"
          :items="backgrounds"
        />
      </ClientOnly>
    </div>
  </div>
</template>
